import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import DocumentTitle from 'react-document-title';
import { connect } from 'react-redux';

import { makeGetTheme } from 'selectors/app-props';

import { setPublicToken } from 'services/public-share-service';

import ThemeProvider from 'context/ThemeProvider';

import PoweredBy from 'components/PoweredBy';

class PublicPage extends PureComponent {
    componentDidMount() {
        if (this.props.params.publicToken) {
            setPublicToken(this.props.params.publicToken);
        }
    }

    componentWillUnmount() {
        setPublicToken(null);
    }

    render() {
        return (
            <DocumentTitle title="Nifty">
                <div className="app-inner">
                    <div className="app-main">
                        <div className="wrapper">
                            <div className="main">
                                <div className="project-pane">
                                    <ThemeProvider theme={this.props.theme}>
                                        { this.props.children }
                                    </ThemeProvider>
                                </div>
                            </div>
                        </div>

                        <div className="public-page-overlay">
                            <Link to="signup" className="btn btn-success">Sign up</Link>

                            <Link to="login" className="btn btn-secondary">Log in</Link>

                            <PoweredBy />
                        </div>
                    </div>
                </div>
            </DocumentTitle>
        );
    }
}

const makeMapStateToProps = () => {
    const getTheme = makeGetTheme();

    return ({ appProps }) => ({
        theme: getTheme(appProps)
    });
};

export default connect(makeMapStateToProps)(PublicPage);
